import { TranslateService } from '@ngx-translate/core';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
var FuseTranslationLoaderService = /** @class */ (function () {
    function FuseTranslationLoaderService(translateService) {
        this.translateService = translateService;
    }
    FuseTranslationLoaderService.prototype.loadTranslations = function () {
        var _this = this;
        var locales = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            locales[_i] = arguments[_i];
        }
        locales.forEach(function (locale) {
            _this.translateService.setTranslation(locale.lang, locale.data, true);
        });
    };
    FuseTranslationLoaderService.prototype.loadJsonTranslations = function (_a) {
        var english = _a.english, portuguese = _a.portuguese, spanish = _a.spanish;
        this.loadTranslations({ lang: 'en', data: english }, { lang: 'pt', data: portuguese }, { lang: 'es', data: spanish });
    };
    FuseTranslationLoaderService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FuseTranslationLoaderService_Factory() { return new FuseTranslationLoaderService(i0.ɵɵinject(i1.TranslateService)); }, token: FuseTranslationLoaderService, providedIn: "root" });
    return FuseTranslationLoaderService;
}());
export { FuseTranslationLoaderService };
